module.exports = __webpack_public_path__ + "img/logo.19c61d9d.png";